import { dsClass } from '../../../common/constants/dsClasses.js';
import { SubscriptionAddonCode } from '../../../common/enums';
import { companyNumberMsg, t } from '../../../common/i18n/index.js';
import { lookupAddonPrice } from '../../../common/utils/addOnUtils';
import { formatPhoneNumber } from '../../../common/utils/phoneNumberUtils.js';
import { formatSumToString } from '../../../common/utils/priceUtils';
import { Loading } from '../../Loading/index.js';
import { GutterStyle, SelectOneList, type SelectOneListItemProps } from '../../SelectOneList/index.js';
import { NumberFetchingError } from '../NumberFetchingError.js';
import { ShowMoreButton } from './ShowMoreButton.js';
import type { NumberRangeData } from '../../../common/loaders.js';
import type { AssociationRecord } from '../../../legacy/cloudsense-add-on-dependency-engine/AddOnManagerOnline';

export const CorporateNumberSelect = ({
  rangeNumbers,
  selectedValue,
  addOnAssociations,
  onSelect,
  retryAction,
  onDisplayMoreNumbers,
}: {
  rangeNumbers?: NumberRangeData;
  selectedValue?: string;
  addOnAssociations: AssociationRecord[];
  onSelect: (field: string, value: string) => void;
  retryAction: () => void;
  onDisplayMoreNumbers: () => void;
}) => {
  if (!rangeNumbers) {
    return null;
  }

  if (rangeNumbers.errors) {
    return (
      <div id="subscription-company-number" className="of-select-number-list__error">
        <NumberFetchingError errors={rangeNumbers.errors} retryAction={retryAction} />
      </div>
    );
  }

  const vakioCorpAddon = lookupAddonPrice(addOnAssociations, SubscriptionAddonCode.VAKIO_CORPORATE_NUMBER);
  const vakioRegionalAddon = lookupAddonPrice(addOnAssociations, SubscriptionAddonCode.VAKIO_REGIONAL_NUMBER);

  const displayedNumbers = rangeNumbers.displayedNumbers || [];

  const isLoading =
    !rangeNumbers.displayedNumbers || !rangeNumbers.allNumbers || rangeNumbers.displayedNumbers.length < 1;

  const displayShowMoreButton =
    rangeNumbers?.allNumbers && rangeNumbers.allNumbers.length > displayedNumbers.length && !isLoading;

  const getOption = (phoneNumber: string): SelectOneListItemProps => ({
    element: (
      <div className="of-attach-pbx-content__number-range-row of-attach-pbx-content__selection of-select-number-list">{`${formatPhoneNumber(
        phoneNumber,
        true
      )}`}</div>
    ),
    isSelected: selectedValue === phoneNumber,
    onClick: () => onSelect('corporateNumber', phoneNumber),
  });

  return (
    <div id="subscription-company-number" className={dsClass.MARGIN_TOP_4}>
      <div className={dsClass.FONT_SIZE_LARGE}>{t.D9TG(companyNumberMsg)}:</div>
      <div className="ea-disclaimertext">
        {t.QTLF(
          'Service price {0}/month for business numbers (with prefixes such as 010, 020, etc.) and {1}/month for other numbers.',
          formatSumToString(vakioCorpAddon!.monthlyRecurringCharge),
          formatSumToString(vakioRegionalAddon!.monthlyRecurringCharge)
        )}
      </div>
      <SelectOneList
        disableIcon={true}
        gutterStyle={GutterStyle.Minimal}
        maxItemsAsideDesktop={4}
        maxItemsAsideLaptop={4}
        maxItemsAsideTablet={3}
        options={displayedNumbers.map(phoneNumber => getOption(phoneNumber))}
      />
      {isLoading && <Loading topPadding={2} text />}
      {displayShowMoreButton && <ShowMoreButton onClick={() => onDisplayMoreNumbers()} />}
    </div>
  );
};
